import { Component, Input, ChangeDetectionStrategy, HostListener } from '@angular/core';
import { LoggedUserModel } from 'app/models';
import { LoggedUserService } from 'app/services';

@Component({
    selector: 'app-user-panel',
    templateUrl: 'user-panel.component.html',
    styleUrls: ['./user-panel.component.scss'],
    standalone: false,
})

export class UserPanelComponent {
  @Input()
  menuItems: any;

  @Input()
  menuMode = 'context';

  loggedUser: LoggedUserModel | null = null;
  dropdownOpen = false;

  constructor(private loggedUserService: LoggedUserService) {
    this.loggedUserService.currentUser.subscribe(u => {
      this.loggedUser = u;
    });
  }

  // skipcq: JS-0323
  onMenuItemClick(item: any) {
    if (item.onClick) {
      item.onClick();
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const el = (event.target as HTMLElement).closest('.user-panel');
    if (!el) {
      this.dropdownOpen = false;
    }
  }
}
